export const FulfillmentChannel = {
  OrderAheadOnly: 'ORDER_AHEAD_ONLY',
  InStoreOnly: 'IN_STORE_ONLY',
} as const;

export type FulfillmentChannelValue = (typeof FulfillmentChannel)[keyof typeof FulfillmentChannel];

export type FulfillmentChannelFormValues = {
  fulfillmentChannelConstraint: {
    isEnabled: boolean;
    channel: FulfillmentChannelValue;
  };
};
